export default import.meta.ROLLDOWN_FILE_URL_ykb1zIozoJBMq4UvQnlhcQ